module.exports = "https://web-assets.ifttt.com/packs/media/home/diy_background-785d2664.png";